import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { getAuthenticatedHomeRoute } from "../../Util/authRedirect";

const PrivatePublicRoute = () => {
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const authToken = userData?.token || localStorage.getItem("token");
  // const isTemporaryPassword = useSelector(
  //   (state) => state?.authSlice.userData?.payload?.isTemporaryPassword
  // );
  return !authToken ? (
    <Outlet />
  ) : (
    <Navigate
      to={getAuthenticatedHomeRoute(userData)}
      // to={isTemporaryPassword ? '/update-password' : '/Dashboard'}
    />
  );
};

export default PrivatePublicRoute;
